import { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { ThreeCircles } from "react-loader-spinner";
import "./CreateOrEditEditorComponent.css";
import { ToastContainer } from "react-toastify";
import RulesModal from '../RulesPage/components/RulesModal/RulesModal';
import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
import "../../../../node_modules/@syncfusion/ej2-documenteditor/styles/material.css";
import "../../../../node_modules/@syncfusion/ej2-ribbon/styles/material.css";

import { DocumentEditorContainerComponent, Toolbar, Ribbon } from '@syncfusion/ej2-react-documenteditor';
import CustomButton from "../../reusable_components/custom_button_component/Button";

import TemplateNamingModal from "./components/TemplateNamingModal/TemplateNamingModal";
import ContentBlockEditorModal from '../ContentBlocksPage/components/ContentBlockEditorModal/ContentBlockEditorModal';

import {
  convertDocToSFDT
} from "./CreateOrEditEditorComponent.service";

import {
  handleContentBlockShow, handleContentBlockHide,
  onCreate, handleClose, handleDragOver, handleDrop, onHandleRulesModalClose,
  handleSaveAndNextBtnClick,
  processFieldReplacements,
  convertDocToBase64,
  initializeEditorEventListeners,
  setupOverlayScrolling,
  fetchTemplateData,
  prepareRecipientOptions,
  updateRecipientStorage,
  filterActiveRules,
  applyTemplateData,
  removeToolbarElements,
  getFieldRulesRowData,
  convertRecipientsToClientDetails
} from './CreateOrEditEditorComponent.utils';

import ContentBlocksPanel from "./components/ContentBlocksPanel/ContentBlocksPanel";
import RulesPanel from "./components/RulesPanel/RulesPanel";
import SelectedFieldsPanel from "./components/SelectedFieldsPanel/SelectedFieldsPanel";
import SignatureFieldsPanel from "./components/SignatureFieldsPanel/SignatureFieldsPanel";
import ClientDetailsPanel from "./components/ClientDetailsPanel/ClientDetailsPanel";
import { isEqual } from "lodash";
import {
  EngagementLetterWizardSharedData,
} from "../CreateEngagementLetterWizard/CreateEngagementLetterWizard.utils";
import { AlertModal } from "../../../Reusables/components/AlertModal/AlertModal";
import { TemplateRuleRow } from "../RulesPage/components/RulesModal/RulesModal.types";
import { Recipient } from "../EngagementLetterDetailsPage/components/RecipientsCellRenderer/RecipientsCellRenderer.types";
import { syncfusionDocEditorServiceUrl } from "../../../constants/env";

DocumentEditorContainerComponent.Inject(Toolbar, Ribbon);

export interface DocumentEditorContainer extends HTMLDivElement {
  documentEditor: {
    saveAsBlob: (format: string) => Promise<Blob>;
    layoutType?: string;
    [key: string]: any;
  };
  restrictEditing: boolean;
  showPropertiesPane: boolean;
  resize: () => void;
}

export interface CreateOrEditEditorComponentProps {
  getcontent?: boolean;
  dataloader?: boolean;
  showheader?: boolean;
  resize?: number;
  forwizard?: boolean;
  docfilename: string;
  basedata?: any;
  edittype?: string;
  restrictediting?: boolean;
  setcontent?: (base64: string | undefined) => void;
  allfieldsmap?: Record<string, any[]>;
  templateId?: string | number;
  lastFocusedFieldRef?: React.RefObject<string | null>;
  onHide?: () => void;
  processedTemplateId?: number;
  clientMasterId?: number;
  pdffilename?: string;
  onLoadingChange?: (val: boolean) => void;
  setSharedData?: (data: any) => void;
  sharedData?: EngagementLetterWizardSharedData;
  setEditorContainerScope?: (val: any) => void;
  recipientsJson?: Recipient[];
}

export interface RecipientOption {
  label: string;
  value: string;
}

export type EditType = "Template" | "EngagementLetter";

const CreateOrEditEditorComponent: React.FC<CreateOrEditEditorComponentProps> = (props) => {
  const [refreshRules, setRefreshRules] = useState<boolean>(false);
  const [nextStepStatus, setNextStepStatus] = useState<boolean>(false);
  const [addRulesModalShow, setAddRulesModalShow] = useState<boolean>(false);
  const [templateFieldRulesRowData, setTemplateFieldRulesRowData] = useState<any[]>([]);
  const [templateFieldRulesList, setTemplateFieldRulesList] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(JSON.parse(localStorage.getItem('isEdit') || 'false'));
  const [namingModalShow, setNamingModalShow] = useState<boolean>(false);
  const [defaultValue, setDefaultValue] = useState<any>(null);
  const containerRef = useRef<DocumentEditorContainer>(null);
  const [selectedFieldsList, setSelectedFieldsList] = useState<any[]>([]);
  const [signaturesList, setSignaturesList] = useState<any[]>([]);
  const [editType, setEditType] = useState<EditType>(
    (props.edittype as EditType) || (localStorage.getItem("edit_type") as EditType) || "Template"
  );
  const saveTemplateButtonRef = useRef<HTMLButtonElement>(null);
  const [selectedRecipient, setSelectedRecipient] = useState<RecipientOption>({ label: "ClientEmail", value: "ClientEmail" });
  const [recipientOptions, setRecipientOptions] = useState<RecipientOption[]>([
    { label: "ClientEmail", value: "ClientEmail" }
  ]);
  const [inputFields, setInputFields] = useState<any[]>([]);
  const [contentBlocksData, setContentBlocksData] = useState<any[]>([]);
  const [contentBlockModelShow, setContentBlockModelShow] = useState<boolean>(false);
  const [contentBlockId, setContentBlockId] = useState<string | undefined>(undefined);
  const [blockName, setBlockName] = useState<string>("");
  const [blockData, setBlockData] = useState<string>("");
  const [active, setActive] = useState<"Y" | "N">("Y");
  const [status, setStatus] = useState<string>();
  const [clientDetails, setClientDetails] = useState<any>({});
  const [showHeader, setShowHeader] = useState<boolean | undefined>(props.showheader);
  const [baseData, setBaseData] = useState<any>(props.basedata);
  const [docFileName, setDocFileName] = useState<string>(props.docfilename);
  const [restrictEditing, setRestrictEditing] = useState<boolean>(props.restrictediting !== undefined && props.restrictediting !== null ? props.restrictediting : false);
  const [getContent, setGetContent] = useState<any>(props.getcontent);
  const [originalSFDT, setOriginalSFDT] = useState<any>();
  const [loadingEditor, setLoadingEditor] = useState<boolean | undefined>(props.dataloader ?? true);
  const [resizeTrigger, setResizeTrigger] = useState<any>(props.resize);

  const buttonPosition = saveTemplateButtonRef.current
    ? saveTemplateButtonRef.current.getBoundingClientRect()
    : { top: 0, left: 0, bottom: 0 };

  const [clientDetailsOpen, setClientDetailsOpen] = useState<boolean>(false);
  const [contentBlocksOpen, setContentBlocksOpen] = useState<boolean>(false);
  const [rulesOpen, setRulesOpen] = useState<boolean>(true);
  const [selectionsOpen, setSelectionsOpen] = useState<boolean>(true);
  const [signaturesOpen, setSignaturesOpen] = useState<boolean>(false);
  const [allFieldsMap, setAllFieldsMap] = useState<any>(props.allfieldsmap);
  const [editorContainerScope, setEditorContainerScope] = useState<DocumentEditorContainer>();
  const [showAlert, setShowAlert] = useState(false);
  const [selectedRule, setSelectedRule] = useState<TemplateRuleRow | null>(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    if (props.recipientsJson) {
      const derived = convertRecipientsToClientDetails(props.recipientsJson);
      setClientDetails(derived);
    }
  }, []);

  useEffect(() => {
    if ((originalSFDT && props.forwizard) || 
      (originalSFDT && !props.forwizard && props.processedTemplateId) ||
      (originalSFDT && props.templateId && dataLoaded)) {
      setLoadingEditor(false);
      setDataLoaded(false);
    }
  }, [originalSFDT, dataLoaded]);
  
  useEffect(() => {
    if (props.getcontent !== undefined && props.getcontent !== null) {
      setGetContent(props.getcontent);
    }
  }, [props.getcontent]);

  useEffect(() => {
    if(props.dataloader === undefined)
      return;
    setLoadingEditor(true);
    setRestrictEditing(true);
  }, [props.dataloader]);
  
  useEffect(() => {
    if(props.setSharedData) {
      props.setSharedData((prev: any) => ({
        ...prev,
        isEditorLoading: !!loadingEditor,
      }));
    }
  }, [loadingEditor]);

  useEffect(() => {
    setResizeTrigger(props.resize);
  }, [props.resize]);

  useEffect(() => {
    if (props.forwizard) {
      setRulesOpen(false);
      setSelectionsOpen(false);
      setSignaturesOpen(false);
    }
  }, [props.forwizard]);

  useEffect(() => {
    setDocFileName(props.docfilename);
  }, [props.docfilename]);

  useEffect(() => {
    setBaseData(props.basedata);
  }, [props.basedata]);

  useEffect(() => {
    if (props.edittype !== undefined && props.edittype !== null) {
      setEditType(props.edittype as EditType);
    } else {
      const storedType = localStorage.getItem("edit_type") || "";
      if (storedType === "Template" || storedType === "EngagementLetter") {
        setEditType(storedType);
      } else {
        setEditType("Template");
      }
    }
  }, [props.edittype]);

  useEffect(() => {
    if (containerRef.current?.documentEditor) {
      // containerRef.current.documentEditor.layoutType = "WebLayout";
      containerRef.current.resize();
      if(props.forwizard) containerRef.current.documentEditor.fitPage("FitPageWidth");
    }
  }, [resizeTrigger]);

  useEffect(() => {
    removeToolbarElements();
  
    if (editType !== "Template" || !props.templateId || props.forwizard) return;
  
    setLoadingEditor(true);
  
    const { recipientOptions, defaultRecipient, inputFields } = prepareRecipientOptions();
    setSelectedRecipient(defaultRecipient);
    setRecipientOptions(recipientOptions);
    setInputFields(inputFields);
  
    const fieldRulesRowData = getFieldRulesRowData();
  
    const stateFns = {
      setSignaturesList,
      setSelectedFieldsList,
      setTemplateFieldRulesRowData,
      setTemplateFieldRulesList,
      setContentBlocksData,
      setDataLoaded,
      templateId: props.templateId,
      forwizard: props.forwizard
    };
  
    fetchTemplateData({
      templateId: props.templateId,
      fieldRulesRowData
    }).then(data => {
      applyTemplateData(
        data.firmTemplateFields,
        data.fieldRules,
        data.contentBlocks,
        stateFns
      );
    }).catch(error => {
      console.error("Error fetching template data:", error);
    });
  
    return () => {
      localStorage.removeItem("FieldRulesRowData");
      removeToolbarElements();
    };
  }, [props.templateId]);

  useEffect(() => {
    if (props.forwizard ? baseData : (baseData || docFileName)) {
      setAllFieldsMap({});
      convertDocToSFDT({
        docFileName,
        baseData,
        editType,
        forwizard: props.forwizard!,
        setOriginalSFDT,
        containerRef
      });
    }
  }, props.forwizard ? [baseData] : [baseData, docFileName]);

  useEffect(() => {
    containerRef.current = editorContainerScope!;
    
    if (props.setEditorContainerScope) {
      props.setEditorContainerScope(editorContainerScope!);
    }

    if (containerRef?.current?.documentEditor) {
      // Set up editor event listeners
      return initializeEditorEventListeners({
        containerRef,
        handleDragOver,
        handleDrop,
        setSelectionsOpen,
        setSignaturesOpen
      });
    }
  }, [editorContainerScope])

  useEffect(() => {
    if (containerRef?.current?.documentEditor) {
      if (restrictEditing) {
        containerRef.current.restrictEditing = true;
        containerRef.current.showPropertiesPane = false;
        const element = document.querySelector('.e-de-pane');
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }
      else {
        containerRef.current.restrictEditing = false;
      }
    }
  }, [restrictEditing])

  useEffect(() => {
    if (templateFieldRulesRowData) {
      const filteredRuleList = filterActiveRules(templateFieldRulesRowData);
      setTemplateFieldRulesList(filteredRuleList);
    }
  }, [templateFieldRulesRowData]);

  useEffect(() => {
    updateRecipientStorage(selectedRecipient, recipientOptions);
  }, [selectedRecipient])

  useEffect(() => {
    if (props.allfieldsmap !== undefined && props.allfieldsmap !== null && 
      !isEqual(allFieldsMap, props.allfieldsmap) && 
      (typeof props.allfieldsmap === "object" && Object.keys(props.allfieldsmap).length !== 0)) {
      setAllFieldsMap(props.allfieldsmap)
    }
  }, [props.allfieldsmap])

  useEffect(() => {
    setupOverlayScrolling();
  }, []);

  return (
    <div
      id="create-template-modal"
    >

      {
        <div className={loadingEditor !== false || (!props.templateId && !props.processedTemplateId) ? "disable-editor-overlay blurr-background" : ""}>
          {
            props.templateId || props.processedTemplateId ?
              (loadingEditor !== false || (!baseData && !docFileName)) ?
                <div className="flex-row-center-center" style={{ marginLeft: 5 }}>
                  <div style={{ width: "fit-content", padding: 0 }}>
                    <ThreeCircles
                      height="35"
                      width="35"
                      color="#4fa94d"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel="three-circles-rotating"
                      outerCircleColor="var(--theme1_tertiary)"
                      innerCircleColor="var(--theme1_secondary)"
                      middleCircleColor="var(--theme1_primary)"
                    />
                  </div>
                  <h6 style={{ width: "fit-content", marginLeft: 10 }}>
                    {props.forwizard && props.processedTemplateId !== -1 ? "Processing your template" : "Loading your data"}
                  </h6>
                </div> : <></>
              :
              <h6>Please select a template to load.</h6>
          }
        </div>
      }
      {!isEdit && namingModalShow && (
        <div
          style={{
            position: 'absolute',
            top: buttonPosition.bottom + window.scrollY + 5,
            left: buttonPosition.left + window.scrollX - 210
          }}
        >
          <TemplateNamingModal
            finalizeTemplate={(originalFileName: string) =>
              handleSaveAndNextBtnClick({
                originalFileName,
                editType,
                docFileName,
                recipients: `[${recipientOptions.map(opt => `"{{${opt.value}}}"`).join(",")}]`,
                props,
                templateFieldRulesRowData,
                clientDetails,
                containerRef,
                setNextStepStatus,
                setIsEdit,
                handleClose
              })
            }
            onHide={() => setNamingModalShow(false)}
          />
        </div>
      )}

      {/* Header */}
      {(showHeader === undefined || showHeader) && (
        <div className="modal-header" style={{ paddingBottom: 0 }}>
          <Row className="button-row flex-row-center-space">
            <Col md={9} className="d-flex justify-content-start">
              <p
                className="display-6"
                style={{
                  height: 'fit-content',
                  paddingLeft: '-3rem',
                  marginBottom: 0,
                  width: 'fit-content',
                  alignItems: "center",
                  display: "flex"
                }}
              >
                {localStorage.getItem('letter_file_name') === 'EngagementLetter.pdf'
                  ? 'Create'
                  : 'Edit'}{' '}
                {editType === 'Template' ? 'Template' : 'Engagement Letter'}
                {localStorage.getItem('letter_file_name') !== 'EngagementLetter.pdf' &&
                editType === 'Template' &&
                localStorage.getItem('doc_original_file_name') && (
                  <span
                    style={{
                      textTransform: 'none',
                      fontSize: '1.25rem',
                      color: '#6c757d',
                      fontWeight: '500',
                      paddingLeft: '0.75rem',
                    }}
                  >
                    ({localStorage.getItem('doc_original_file_name') ? localStorage.getItem('doc_original_file_name')!.replace(/\.[^/.]+$/, '') : ''})
                  </span>
                )}
              </p>
            </Col>
            <Col md={3} className="d-flex flex-row-center-end">
              <div style={{ marginLeft: '1rem' }}>
                <CustomButton
                  forwardedRef={saveTemplateButtonRef}
                  onclick={() =>
                    isEdit
                      ? handleSaveAndNextBtnClick({
                        originalFileName: localStorage.getItem('doc_original_file_name') ?? "Temp.docx",
                        editType,
                        docFileName,
                        recipients: `[${recipientOptions.map(opt => `"{{${opt.value}}}"`).join(",")}]`,
                        props,
                        templateFieldRulesRowData,
                        clientDetails,
                        containerRef,
                        setNextStepStatus,
                        setIsEdit,
                        handleClose
                      })
                      : setNamingModalShow(true)
                    
                  }
                  progress={nextStepStatus}
                  content={<>
                    Finalize{' '}
                    {editType === 'EngagementLetter' ? 'Letter' : 'Template'}
                  </>}
                />
              </div>
              <div style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                <CustomButton
                  onclick={() => setShowAlert(true)}
                  content={"Close"}
                />
              </div>
            </Col>
          </Row>
        </div>
      )}

      {/* Body */}
      <div className="modal-body preview-modal">
        <>
          <>
            {showAlert && (
              <AlertModal
                show={showAlert}
                onHide={() => setShowAlert(false)}
                title="Are you sure?"
                message="Closing this will discard all the unsaved data. Do you want to continue?"
                type="warning"
                listItems={[]}
                footerButtons={[
                  { label: "Cancel", onClick: () => setShowAlert(false), type: "quinary" },
                  {
                    label: "Continue",
                    onClick: () =>
                      handleClose(props),
                    type: "tertiary"
                  },
                ]}
              />
            )}
            {contentBlockModelShow && (
              <ContentBlockEditorModal
                mode="view"
                contentBlockId={contentBlockId}
                blockName={blockName}
                blockData={blockData}
                active={active}
                status={status}
                onHide={() => handleContentBlockHide(setContentBlockModelShow)}
              />
            )}
            {addRulesModalShow && selectedRule && (
              <RulesModal
                ruleData={selectedRule}
                selectedFieldsList={selectedFieldsList}
                onHide={() => setAddRulesModalShow(false)}
                mode={"view"}
              />
            )}

            <Row className="template-editor no-gutter">
              {editType !== 'Template' && props.forwizard !== true && (
                <ClientDetailsPanel
                  clientDetails={clientDetails}
                  clientDetailsOpen={clientDetailsOpen}
                  setClientDetailsOpen={setClientDetailsOpen}
                  setClientDetails={setClientDetails}
                  setRecipientOptions={setRecipientOptions}
                />
              )}

              {editType === 'Template' && props.forwizard !== true && (
                <>
                  <ContentBlocksPanel
                    contentBlocksOpen={contentBlocksOpen}
                    setContentBlocksOpen={setContentBlocksOpen}
                    setRulesOpen={setRulesOpen}
                    contentBlocksData={contentBlocksData}
                    setContentBlockId={setContentBlockId}
                    setBlockName={setBlockName}
                    setBlockData={setBlockData}
                    setActive={setActive}
                    setStatus={setStatus}
                    setContentBlockModelShow={setContentBlockModelShow}
                    handleContentBlockShow={handleContentBlockShow}
                    forwizard={false}
                  />


                  <RulesPanel
                    rulesOpen={rulesOpen}
                    setRulesOpen={setRulesOpen}
                    setContentBlocksOpen={setContentBlocksOpen}
                    templateFieldRulesList={templateFieldRulesList}
                    templateFieldRulesRowData={templateFieldRulesRowData}
                    setSelectedRule={setSelectedRule}
                    setAddRulesModalShow={setAddRulesModalShow}
                    refreshRules={refreshRules}
                    forwizard={false}
                  />
                </>
              )}

              <div id="editor">
                <div className="editor">
                  <DocumentEditorContainerComponent
                    id="container"
                    ref={(scope: any) => {
                      setEditorContainerScope(scope as unknown as DocumentEditorContainer);
                    }}
                    serviceUrl={syncfusionDocEditorServiceUrl}
                    enableToolbar={props.forwizard ? false : true}
                    enableTrackChanges={false}
                    showPropertiesPane={false}
                    enableAutoFocus={false}
                    toolbarMode="Ribbon"
                    created={() => onCreate(containerRef, props.forwizard!)}
                  />
                </div>
              </div>

              {editType === 'Template' && props.forwizard !== true && (
                <>
                  <SelectedFieldsPanel
                    selectionsOpen={selectionsOpen}
                    setSelectionsOpen={setSelectionsOpen}
                    setSignaturesOpen={setSignaturesOpen}
                    selectedFieldsList={selectedFieldsList}
                    containerRef={containerRef}
                    forwizard={false} // or true if needed
                  />
                  <SignatureFieldsPanel
                    signaturesOpen={signaturesOpen}
                    setSignaturesOpen={setSignaturesOpen}
                    setSelectionsOpen={setSelectionsOpen}
                    inputFields={inputFields}
                    setInputFields={setInputFields}
                    recipientOptions={recipientOptions}
                    selectedRecipient={selectedRecipient}
                    setRecipientOptions={setRecipientOptions}
                    setSelectedRecipient={setSelectedRecipient}
                    containerRef={containerRef}
                    signaturesList={signaturesList}
                  />
                </>
              )}
            </Row>
          </>
        </>
        <ToastContainer />
      </div>
    </div>
  );
};

export default CreateOrEditEditorComponent;
